// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import store from './store/Store'
import Vuetify from 'vuetify'
import IdleVue from 'idle-vue'
import Raygun from './services/Raygun'
import 'vuetify/dist/vuetify.min.css'
import VueWait from 'vue-wait'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import wait from './lib/wait'

const eventsHub = new Vue()

sync(store, router)

Vue.config.productionTip = false
Vue.use(Toast)
Vue.use(VueWait)
Vue.use(VueI18n)
Vue.use(Vuetify)
Vue.use(IdleVue, { eventEmitter: eventsHub, store })

Vue.config.errorHandler = (error, vm) => {
  Raygun.send(error)
}

const savedLocale = window.localStorage.getItem('locale')

const i18n = new VueI18n({
  locale: savedLocale || 'en',
  fallbackLocale: 'ee',
  messages: require('./i18n/strings')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>',
  wait
})



// WEBPACK FOOTER //
// ./src/main.js